import type { EventStatus, RecurrenceConfig } from "../types";
import { EVENT_STATUS_LABEL_KEYS, EVENT_STATUS_COLORS } from "../constants";
import { RefreshCw } from "lucide-react";
import { useLocale } from "../../../context/LanguageContext";

function recurrenceLabel(recurrence: RecurrenceConfig, t: (key: string, params?: Record<string, string | number>) => string): string {
  const v = recurrence.intervalValue;
  const unit = recurrence.intervalUnit;
  if (unit === "MONTHS" && v === 1) return t("events.recurrence.monthly");
  if (unit === "WEEKS" && v === 1) return t("events.recurrence.weekly");
  if (unit === "DAYS" && v === 1) return t("events.recurrence.daily");
  const unitLabel = t(`shared.recurrenceUnitShort.${unit}`);
  return t("events.recurrence.every", { value: v, unit: unitLabel });
}

interface EventStatusBadgeProps {
  status: EventStatus;
  recurrence?: RecurrenceConfig;
  className?: string;
}

export function EventStatusBadge({ status, recurrence, className = "" }: EventStatusBadgeProps) {
  const { t } = useLocale();
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <span
        className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${EVENT_STATUS_COLORS[status]}`}
      >
        {t(EVENT_STATUS_LABEL_KEYS[status])}
      </span>
      {recurrence?.enabled && (
        <span className="inline-flex items-center rounded-full bg-primary/10 px-2 py-0.5 text-xs font-medium text-primary">
          <RefreshCw className="mr-0.5 h-3 w-3" />
          {recurrenceLabel(recurrence, t)}
        </span>
      )}
    </span>
  );
}
